<template>
    <modal id="brand-modal"
           v-model="showModal"
           :title="generateModalTitle('brand')"
           @submit="submitData"
           :loading="loading"
           :preloader="preloader"
    >
        <form method="post"
              :data-url='selectedUrl ? selectedUrl : apiUrl.BRANDS'
              ref="form"
              @submit.prevent="submitData"
        >
            <app-form-group
                    :label="$t('name')"
                    v-model="formData.name"
                    :placeholder="$placeholder('brand', 'name')"
                    :error-message="$errorMessage(errors, 'name')"
            />
        </form>
    </modal>
</template>

<script>
    import ModalMixin from "../../../Mixins/ModalMixin";
    import FormHelperMixin from "../../../Mixins/FormHelperMixin";

    export default {
        name: "BrandCreateEdit",
        mixins: [ModalMixin, FormHelperMixin],
        methods: {
            afterSuccess({data}) {
                this.formData = {};
                $('#brand-modal').modal('hide');
                this.$emit('input', false);
                this.toastAndReload(data.message, 'brands-table');
            },
            afterSuccessFromGetEditData(response) {
                this.preloader = false;
                this.formData = response.data;
            },
        },
    }
</script>

<style scoped>

</style>